import React, { ReactElement } from 'react';

import { Container, Grid, makeStyles, Theme, Typography } from '@fluentsms/components';

import NoSearchResults from './images/NoSearchResults.svg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  logo: {
    width: 150,
    height: 160,
    margin: theme.spacing(2, 0),
  },
}));

export const NoSearchResultsError = (): ReactElement | null => {
  const classes = useStyles();

  return (
    <Grid>
      <Container className={classes.container} data-testid="no-search-result-error">
        <Typography variant="h1">No Results Found</Typography>
        <img src={NoSearchResults} alt="no-search-result-error" data-testid="no-results-svg" className={classes.logo} />
        <Typography variant="body1">Please try a different search term.</Typography>
      </Container>
    </Grid>
  );
};
